import { Icon, IconProps } from ".";

export const WalletModal = (props: IconProps) => {
  return (
    <Icon {...props} fill="currentColor" viewBox="0 0 24 24">
      <>
        <path d="M6.55556 5H12.7778V6.55556H6.55556V5Z" />
        <path d="M6.55556 17.4444H5V6.55556H6.55556V17.4444Z" />
        <path d="M6.55556 17.4444H12.7778V19H6.55556V17.4444Z" />
        <path d="M15.8889 8.11111H14.3333V9.66667H15.8889V11.2222H9.66667V12.7778H15.8889V14.3333H14.3333V15.8889H15.8889V14.3333H17.4444V12.7778H19V11.2222H17.4444V9.66667H15.8889V8.11111Z" />{" "}
      </>
    </Icon>
  );
};
